import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const BannerSlider = {
    init() {
        if ($('.bannerSwiper').length > 0) {
            this.initSlider();
        }
    },

    initSlider() {
        new Swiper($('.bannerSwiper')[0], {
            loop: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            speed: 1000,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            modules: [Navigation, Pagination, Autoplay],

            on: {
                init: function () {
                    setEqualHeight();
                    toggleSearch(this);
                },

                slideChange: function () {
                    toggleSearch(this);
                },

                imagesReady: function () {
                    // important if slides contain images
                    setEqualHeight();
                },
            },
        });

        function setEqualHeight() {
            let maxHeight = 0;

            const $slides = $('.bannerSwiper .swiper-slide');
            const $bannerSlides = $('.bannerSwiper .swiper-slide .banner');

            // reset height first
            $slides.each(function () {
                this.style.height = 'auto';
            });

            // find tallest
            $slides.each(function () {
                const h = this.offsetHeight;
                if (h > maxHeight) maxHeight = h;
                $bannerSlides.minHeight = h + 'px';
            });

            // apply tallest height
            $slides.each(function () {
                this.style.height = maxHeight + 'px';
            });
        }

        function toggleSearch(swiper) {
            if (swiper.realIndex === 0) {
                $('.banner__search').hide();
            } else {
                $('.banner__search').show();
            }
        }

        // recalc on resize
        let resizeTimeout;
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(setEqualHeight, 200);
        });
    },
};

export default BannerSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_banner.js